document.addEventListener('DOMContentLoaded', function () {
  var carousels = document.querySelectorAll('.testimonials-grid--marquee');

  carousels.forEach(function (carousel) {
    // Pause on touch, resume shortly after (hover pause is handled purely in CSS)
    carousel.addEventListener('touchstart', function () {
      carousel.classList.add('is-paused');
    }, { passive: true });

    carousel.addEventListener('touchend', function () {
      setTimeout(function () {
        carousel.classList.remove('is-paused');
      }, 1500);
    });

    // Pause the animation entirely when off-screen, to save CPU/battery
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          carousel.classList.toggle('is-paused', !entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      observer.observe(carousel);
    }
  });
});